export const LINE_NUMBERS_FILTER_TEXT = {
	inputLabel: 'Line number',
	placeholder: 'e.g. LN12345',
	optionsLabel: 'Lines',
};
